var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bad_icon",
    "data-name": "bad icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 38,
    height: 38,
    fill: "#898989",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16168",
    "data-name": "Group 16168",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28243",
    "data-name": "Path 28243",
    d: "M123.3,135.118a11.776,11.776,0,1,1,11.776-11.776A11.788,11.788,0,0,1,123.3,135.118m0-22.513a10.737,10.737,0,1,0,10.737,10.737A10.746,10.746,0,0,0,123.3,112.605",
    transform: "translate(-111.296 -111.342)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28244",
    "data-name": "Path 28244",
    d: "M123.02,135.066a11.963,11.963,0,1,1,4.674-.942A12.014,12.014,0,0,1,123.02,135.066Zm0-23.547a11.547,11.547,0,1,0,11.547,11.547A11.56,11.56,0,0,0,123.02,111.519Zm0,22.508a10.961,10.961,0,1,1,10.961-10.961A10.974,10.974,0,0,1,123.02,134.027Zm0-21.469a10.508,10.508,0,1,0,10.508,10.508A10.52,10.52,0,0,0,123.02,112.558Z",
    transform: "translate(-111.02 -111.066)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28245",
    "data-name": "Path 28245",
    d: "M131.851,132.766a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-123.837 -125.19)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_919",
    "data-name": "Ellipse 919",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(6.404 9.749) rotate(-78.019)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28246",
    "data-name": "Path 28246",
    d: "M154.851,132.766a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-138.864 -125.19)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_920",
    "data-name": "Ellipse 920",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(14.382 9.749) rotate(-78.019)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28247",
    "data-name": "Path 28247",
    d: "M139.968,154.7a.527.527,0,0,1-.514-.514c0-1.85-2.262-3.392-5-3.392s-5,1.508-5,3.392a.514.514,0,1,1-1.028,0c0-2.467,2.673-4.42,6.031-4.42,3.392,0,6.031,1.919,6.031,4.42a.527.527,0,0,1-.514.514",
    transform: "translate(-122.276 -136.275)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28248",
    "data-name": "Path 28248",
    d: "M139.927,154.649a.756.756,0,0,1-.753-.738,2.735,2.735,0,0,0-1.4-2.2,6.774,6.774,0,0,0-6.944-.012,2.731,2.731,0,0,0-1.4,2.217.753.753,0,0,1-1.506,0,4.1,4.1,0,0,1,1.885-3.316,8.327,8.327,0,0,1,9-.013,4.1,4.1,0,0,1,1.872,3.329A.756.756,0,0,1,139.927,154.649Zm-5.627-4.355a6.783,6.783,0,0,1,3.729,1.041,3.982,3.982,0,0,1,1.164,1.145,2.619,2.619,0,0,1,.439,1.43.3.3,0,0,0,.591,0,3.666,3.666,0,0,0-1.684-2.967,7.866,7.866,0,0,0-8.464.013,3.67,3.67,0,0,0-1.7,2.955.3.3,0,0,0,.591,0,3.16,3.16,0,0,1,1.6-2.589A6.818,6.818,0,0,1,134.3,150.294Z",
    transform: "translate(-122.129 -135.998)",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadicon);
export default __webpack_public_path__ + "static/media/badicon.bb76feebc8487226740d4b9b17518294.svg";
export { ForwardRef as ReactComponent };